import React, { useEffect, useState } from 'react'

import { MdBiotech, MdDataExploration, MdEmail, MdLabel, MdMedicalInformation, MdOutlineAnalytics, MdOutlineAppRegistration, MdOutlineEmail, MdOutlineQueryStats, MdOutlineSpaceDashboard, MdOutlineWeb } from "react-icons/md"
import { FaBacteria, FaBowlFood, FaChalkboardUser, FaClipboardQuestion, FaKitMedical } from "react-icons/fa6"
import { HiOutlineUsers, HiUserGroup } from 'react-icons/hi2'
import { HiOutlineDocumentReport } from "react-icons/hi"
import { CgProfile, CgReorder, CgTemplate } from "react-icons/cg"
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie';
import MainHeading from './heading'
import { GiDna1, GiDna2, GiInsectJaws, GiLiver, GiMicroscope, GiReturnArrow, GiTongue } from 'react-icons/gi'
import { FcBiomass } from "react-icons/fc";
import { FaMapMarkedAlt, FaMicroscope, FaShippingFast, FaShoppingCart, FaTicketAlt, FaUpload, FaUserFriends, FaWpforms } from 'react-icons/fa'
import { BiHelpCircle } from 'react-icons/bi'
import { IoFastFood, IoFastFoodOutline, IoTicketSharp } from 'react-icons/io5'
import { BsCalendar2EventFill } from 'react-icons/bs'
import { SiAdobeacrobatreader, SiAmazonsimpleemailservice, SiGoogleadsense, SiGooglemeet } from 'react-icons/si'
import { RiMailSendLine, RiMicroscopeLine, RiSendPlaneLine } from "react-icons/ri";
import { TbReportSearch } from 'react-icons/tb'
import axios from 'axios'

function Sidemanu() {
    const loginemail = Cookies.get("email")
    const loginname = Cookies.get("Name")
    const id = Cookies.get("id")
    const token = Cookies.get("Token")
    const token2 = Cookies.get("Token2")
    const apiurlforbackend = process.env.REACT_APP_APIURL;

    const [manukonssa, setmanukonssa] = useState("0")
    const navigate = useNavigate()

    const [show, setshow] = useState(false)


    const logourl = Cookies.get("logourl") || "empty.gif";
    const backgroundcolor = Cookies.get("backgroundcolor") || "#999";
    const color = Cookies.get("color") || "#000";
    const Buttonbackgroundcolor = Cookies.get("Buttonbackgroundcolor") || "#dddddd";
    const Buttoninsidecolor = Cookies.get("Buttoninsidecolor") || "#000";
    const prinarycolor = Cookies.get("prinarycolor") || "#000";
    const prinarycolortext = Cookies.get("prinarycolortext") || "#000";
    const seconderycolor = Cookies.get("seconderycolor") || "#000";
    const portalid = Cookies.get("portalid") || "";

    const dashboard = Cookies.get("dashboard") || false;
    const microbiome = Cookies.get("microbiome") || false;
    const microbiomePlus = Cookies.get("microbiomePlus") || false;
    const microbiomeAdvanced = Cookies.get("microbiomeAdvanced") || false;
    const oralMicrobiome = Cookies.get("oralMicrobiome") || false;
    const foodSensitivity = Cookies.get("foodSensitivity") || false;
    const foodSensitivityMap = Cookies.get("foodSensitivityMap") || false;
    const allergyMap = Cookies.get("allergyMap") || false;
    const dnaMap = Cookies.get("dnaMap") || false;
    const parasitologyTest = Cookies.get("parasitologyTest") || false;
    const candidaProfile = Cookies.get("candidaProfile") || false;
    const sampleReceived = Cookies.get("sampleReceived") || false;
    const uploadResults = Cookies.get("uploadResults") || false;
    const allPractitioners = Cookies.get("allPractitioners") || false;
    const dataAndAnalytics = Cookies.get("dataAndAnalytics") || false;
    const ordersInformation = Cookies.get("ordersInformation") || false;
    const maps = Cookies.get("maps") || false;
    const shipping = Cookies.get("shipping") || false;
    const whiteLabel = Cookies.get("whiteLabel") || false;
    const academy = Cookies.get("academy") || false;
    const meetings = Cookies.get("meetings") || false;
    const emails = Cookies.get("emails") || false;
    const helpCenter = Cookies.get("helpCenter") || false;
    const profile = Cookies.get("profile") || false;



    // useEffect(() => {
    //     const baseUrl = `${window.location.host}`;
    //     let data = JSON.stringify({
    //         "url": baseUrl
    //     });

    //     let config = {
    //         method: 'post',
    //         maxBodyLength: Infinity,
    //         url: apiurlforbackend + '/get-portal-by-url',
    //         headers: {
    //             'Content-Type': 'application/json'
    //         },
    //         data: data
    //     };

    //     axios.request(config)
    //         .then((response) => {
    //             console.log(JSON.stringify(response.data));
    //             setlogourl(response.data.logourl)
    //             document.title = response.data.bartitle;
    //             setbackgroundcolor(response.data.backgroundcolor)
    //             setcolor(response.data.testcolor)
    //             setButtonbackgroundcolor(response.data.Buttonbackgroundcolor)
    //             setButtoninsidecolor(response.data.Buttoninsidecolor)
    //             setprinarycolor(response.data.prinarycolor)
    //             setprinarycolortext(response.data.prinarycolortext)
    //             setportalid(response.data._id)
    //             setseconderycolor(response.data.seconderycolor)

    //             setDashboard(response.data.dashboard);
    //             setMicrobiome(response.data.microbiome);
    //             setMicrobiomePlus(response.data.microbiomePlus);
    //             setMicrobiomeAdvanced(response.data.microbiomeAdvanced);
    //             setFoodSensitivity(response.data.foodSensitivity);
    //             setFoodSensitivityMap(response.data.foodSensitivityMap);
    //             setDnaMap(response.data.dnaMap);
    //             setParasitologyTest(response.data.parasitologyTest);
    //             setCandidaProfile(response.data.candidaProfile);
    //             setSampleReceived(response.data.sampleReceived);
    //             setUploadResults(response.data.uploadResults);
    //             setAllPractitioners(response.data.allPractitioners);
    //             setDataAndAnalytics(response.data.dataAndAnalytics);
    //             setOrdersInformation(response.data.ordersInformation);
    //             setMaps(response.data.maps);
    //             setShipping(response.data.shipping);
    //             setWhiteLabel(response.data.whiteLabel);
    //             setAcademy(response.data.academy);
    //             setMeetings(response.data.meetings);
    //             setEmails(response.data.emails);
    //             setHelpCenter(response.data.helpCenter);
    //             setProfile(response.data.profile);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }, [])


    useEffect(() => {



        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        const urlencoded = new URLSearchParams();
        urlencoded.append("email", loginemail);

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: urlencoded,
            redirect: "follow"
        };


        fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getmeetschudulebyemail", requestOptions)
            .then((response) => response.json())
            .then(async (result) => {

                if (id === result.id) {
                    setshow(true)
                    //    Cookies.set('Token2', "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd", { expires: 7 }); // Expires in 7 days

                }

            })



            .catch((error) => console.error(error));



    }, [])



    return (
        <div className='mainsidemanu' style={{ color: prinarycolor }} >

           <MainHeading />
     
        </div >
    )
}

export default Sidemanu